import { ValidationErrorResponse } from "../../../services/ValidationError";
import {ServicioEntrenamiento} from "../../../services/entrenamientoServicios";
import {parseCurrency} from "../../../utils/numberUtils";

export interface FormValue {
    wasTouched: boolean,
    isValid: boolean | undefined
}

export interface TextFormValue extends FormValue {
    value: string
}

export interface FormState {
    nombre: TextFormValue,
    descripcion: TextFormValue,
    numeroSesiones: TextFormValue,
    precioTotal: TextFormValue,
}

export const initialFormState: FormState = {
    nombre: { value: "", wasTouched: false, isValid: undefined },
    descripcion: { value: "", wasTouched: false, isValid: undefined },
    numeroSesiones: { value: "0", wasTouched: false, isValid: undefined },
    precioTotal: { value: "0", wasTouched: false, isValid: undefined },
}

export const resetValidStates = (formState: FormState) => {
    Object.keys(formState).forEach(_key => {
        const currentVal: FormValue = (formState as any)[_key] as FormValue;
        (formState as any)[_key] = { ...currentVal, isValid: undefined };
    });
}

export const invalidateStates = (formState: FormState, validationErrorResponse: ValidationErrorResponse) => {
    Object.keys(validationErrorResponse).forEach(errKey => {
        const errKeyStr = errKey as string;
        const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
        (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
    })
}

export const servicioEntrenamientoAFormState = (servicio: ServicioEntrenamiento): FormState => {
    return {
        nombre: {value: servicio?.nombre || '', wasTouched: false, isValid: undefined},
        descripcion: {value: servicio?.descripcion || '', wasTouched: false, isValid: undefined},
        numeroSesiones: {value: servicio?.numeroSesiones.toString() || '', wasTouched: false, isValid: undefined},
        precioTotal: {value: servicio?.precioTotal.toString() || '', wasTouched: false, isValid: undefined},
    };
}

export const formStateAServicioEntrenamiento = (id: string, formState: FormState): ServicioEntrenamiento => {
    return {
        id,
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.value,
        numeroSesiones: Number.parseInt(formState.numeroSesiones.value),
        precioTotal: parseCurrency(formState.precioTotal.value, "$", ",")
    }
}